import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private showAlertSubject = new BehaviorSubject<number>(0);
  public showAlert$: Observable<number> = this.showAlertSubject.asObservable();

  constructor() {}

  showAlert(value: number): void {
    this.showAlertSubject.next(value);
  }

  hideAlert(): void {
    this.showAlertSubject.next(0);
  }

  // Method to be called when API returns false
  handleApiResponse(value: number): void {
    if (value > 0) {
      this.showAlert(value);
    }
    else {
      this.hideAlert();
    }
  }
}
